<div
    class="fraction-container"
    [style.backgroundColor]="styles.backgroundColour"
    [style.width]="barWidth"
>
    <div
        class="max-bar-container left"
        [style.width]="maxWinningwidth"
    >
        <ng-container *ngIf="showHoverTooltip == true; else noHoverNum">
            <div
                class="bar-label-container"
                [style.width]="winningwidth"
            >
                <div class="winning-label">
                    {{
                        winningLabel > 5 ? (winningLabel | number: '1.0-0') : ''
                    }}
                    {{ winningLabel > 5 ? '%' : '' }}
                </div>
                <div
                    class="winning-bar"
                    hoverTooltip
                    [hoverTooltipContent]="hoverTemplate"
                    [hoverTooltipData]="hoverData"
                    [ngClass]="winningClass"
                ></div>
            </div>
        </ng-container>
        <ng-template #noHoverNum>
            <div
                class="bar-label-container"
                [style.width]="winningwidth"
            >
                <div class="winning-label">
                    {{
                        winningLabel >= 5
                            ? (winningLabel | number: '1.0-0')
                            : ''
                    }}
                    {{ winningLabel >= 5 ? '%' : '' }}
                </div>
                <div
                    class="winning-bar"
                    [ngClass]="winningClass"
                    [style.width]="winningwidth"
                ></div>
            </div>
        </ng-template>
    </div>

    <div
        class="max-bar-container center"
        [style.width]="maxneutralwidth"
    >
        <ng-container *ngIf="showHoverTooltip == true; else noHoverneutral">
            <div
                class="bar-label-container"
                [style.width]="neutralwidth"
            >
                <div class="neutral-label">
                    {{
                        neutralLabel >= 5
                            ? (neutralLabel | number: '1.0-0')
                            : ''
                    }}
                    {{ neutralLabel >= 5 ? '%' : '' }}
                </div>
                <div
                    class="neutral-bar"
                    hoverTooltip
                    [hoverTooltipContent]="hoverTemplate"
                    [hoverTooltipData]="hoverData"
                    [ngClass]="neutralClass"
                ></div>
            </div>
        </ng-container>
        <ng-template #noHoverneutral>
            <div
                class="bar-label-container"
                [style.width]="neutralwidth"
            >
                <div class="neutral-label">
                    {{
                        neutralLabel >= 5
                            ? (neutralLabel | number: '1.0-0')
                            : ''
                    }}
                    {{ neutralLabel >= 5 ? '%' : '' }}
                </div>
                <div
                    class="neutral-bar"
                    [ngClass]="neutralClass"
                    [style.width]="neutralwidth"
                ></div>
            </div>
        </ng-template>
    </div>

    <div
        class="max-bar-container right"
        [style.width]="maxlosingwidth"
    >
        <ng-container *ngIf="showHoverTooltip == true; else noHoverDenom">
            <div
                class="bar-label-container"
                [style.width]="losingwidth"
            >
                <div class="losing-label">
                    {{
                        losingLabel >= 5 ? (losingLabel | number: '1.0-0') : ''
                    }}
                    {{ losingLabel >= 5 ? '%' : '' }}
                </div>
                <div class="losing-bar red"></div>
            </div>
        </ng-container>

        <ng-template #noHoverDenom>
            <div
                class="bar-label-container"
                [style.width]="losingwidth"
            >
                <div class="losing-label">
                    {{
                        losingLabel >= 5 ? (losingLabel | number: '1.0-0') : ''
                    }}
                    {{ losingLabel >= 5 ? '%' : '' }}
                </div>
                <div
                    class="losing-bar red"
                    [style.width]="losingwidth"
                ></div>
            </div>
        </ng-template>
    </div>
</div>
